import { Flex } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import { get } from '../../Common/api'
import BoxContext from './BoxContext'
import { CircleMarker, LayerGroup, LayersControl, MapContainer, Popup, TileLayer } from 'react-leaflet'
import Title from 'antd/es/typography/Title'

export default function BoxClusterPage () {
  const [cluster, setCluster] = useState([])
  const { box } = useContext(BoxContext)

  const loadCluster = async () => {
    if (!box) return
    await get({
      url: `admin/boxes/${box.id}/cluster`,
      params: {},
      onSuccess: (json) => {
        setCluster(json)
      },
      onFailure: () => {
      }
    })
  }

  const clusterMarker = (cities, { color, radius }) => {
    return cities.map((city) => {
      const postalPlace = city.postal_place
      return (
        <CircleMarker
          center={postalPlace.coordinates}
          radius={radius}
          pathOptions={{ color, fillColor: color, fillOpacity: 0.35, weight: 1 }}
          key={`${color}_${postalPlace.insee_code}`}
        >
          <Popup >
            <Flex vertical >
              <Title level={5} style={ { margin: 0 } }>{postalPlace.normalized_name}</Title>
              <p style={ { margin: 0 } }>{`${postalPlace.zip_code} - INSEE: ${postalPlace.insee_code || '-'}`}</p>
              <p style={ { margin: 0 } } >{`${city.distance_in_min}min - ${city.distance_in_km}km`}</p>
            </Flex>
          </Popup>
        </CircleMarker>
      )
    })
  }

  useEffect(() => {
    loadCluster()
  }, [box])

  return (
    <>
      {cluster && box &&
        <MapContainer center={box.coordinates} zoom={10} scrollWheelZoom={false} style={{ height: '700px' }}>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <LayersControl position="topright">
            <LayersControl.Overlay name="Grappe étudiée">
              <LayerGroup>
                {clusterMarker(cluster.filter(city => city.studied_cluster), { color: '#1677ff', radius: 15 })}
              </LayerGroup>
            </LayersControl.Overlay>
            <LayersControl.Overlay name="Grappe institutionnelle">
              <LayerGroup>
                {clusterMarker(cluster.filter(city => city.institutional_cluster), { color: '#52c41a', radius: 12 })}
              </LayerGroup>
            </LayersControl.Overlay>
            <LayersControl.Overlay name="Grappe attractivité">
              <LayerGroup>
                {clusterMarker(cluster.filter(city => city.attractivity_cluster), { color: '#fa8c16', radius: 9 })}
              </LayerGroup>
            </LayersControl.Overlay>
            <LayersControl.Overlay name="Grappe observée">
              <LayerGroup>
                {clusterMarker(cluster.filter(city => city.observed_cluster), { color: '#eb2f96', radius: 6 })}
              </LayerGroup>
            </LayersControl.Overlay>
          </LayersControl>
        </MapContainer>
      }
    </>
  )
}
